var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangesBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3017",
    "data-name": "Group 3017",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.325,
    height: 53.327,
    viewBox: "0 0 53.325 53.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11226",
    "data-name": "Rectangle 11226",
    width: 53.325,
    height: 53.327,
    fill: "#22294b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3016",
    "data-name": "Group 3016",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    d: "M31.742,59.776a2.461,2.461,0,0,1-.288-.017,24.654,24.654,0,0,1-12.276-5.071,2.4,2.4,0,0,1-.913-1.746,2.434,2.434,0,0,1,.708-1.867L30.012,40.037a2.4,2.4,0,0,1,1.7-.712,2.476,2.476,0,0,1,1.672.66,2.388,2.388,0,0,1,.76,1.766v15.6a2.418,2.418,0,0,1-.7,1.712A2.381,2.381,0,0,1,31.742,59.776Zm-.027-18.3a.249.249,0,0,0-.184.083L20.494,52.6a.28.28,0,0,0-.082.217.246.246,0,0,0,.093.183,22.5,22.5,0,0,0,11.206,4.629.148.148,0,0,0,.031,0,.249.249,0,0,0,.174-.077.282.282,0,0,0,.082-.2V41.75A.28.28,0,0,0,31.716,41.474Z",
    transform: "translate(-5.176 -11.144)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    d: "M13.531,49.87h0a2.389,2.389,0,0,1-1.892-.917A24.661,24.661,0,0,1,6.567,36.676,2.4,2.4,0,0,1,7.156,34.8a2.434,2.434,0,0,1,1.819-.819h15.6a2.423,2.423,0,0,1,1.713,4.137L15.251,49.157A2.416,2.416,0,0,1,13.531,49.87ZM8.976,36.132a.28.28,0,0,0-.211.1.242.242,0,0,0-.063.192A22.511,22.511,0,0,0,13.33,47.626a.251.251,0,0,0,.2.094.281.281,0,0,0,.2-.082L24.769,36.6a.273.273,0,0,0-.193-.467Z",
    transform: "translate(-1.856 -9.63)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    "data-name": "Path 3447",
    d: "M43.662,39.324h0a2.4,2.4,0,0,1,1.7.713L56.4,51.075a2.434,2.434,0,0,1,.708,1.867,2.4,2.4,0,0,1-.913,1.746,24.658,24.658,0,0,1-12.276,5.071,2.407,2.407,0,0,1-2.694-2.409V41.75a2.389,2.389,0,0,1,.76-1.766A2.476,2.476,0,0,1,43.662,39.324Zm-.025,18.3.03,0A22.509,22.509,0,0,0,54.872,53a.246.246,0,0,0,.093-.183.28.28,0,0,0-.082-.217L43.845,41.557a.249.249,0,0,0-.184-.083h0a.308.308,0,0,0-.205.081.248.248,0,0,0-.078.195v15.6A.274.274,0,0,0,43.636,57.626Z",
    transform: "translate(-11.685 -11.144)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    d: "M24.576,26.9H8.976a2.434,2.434,0,0,1-1.82-.819,2.4,2.4,0,0,1-.588-1.876,24.648,24.648,0,0,1,5.071-12.276,2.389,2.389,0,0,1,1.892-.917,2.416,2.416,0,0,1,1.72.712L26.289,22.765A2.423,2.423,0,0,1,24.576,26.9ZM13.531,13.164a.251.251,0,0,0-.2.094A22.5,22.5,0,0,0,8.7,24.464a.242.242,0,0,0,.062.193.28.28,0,0,0,.212.1h15.6a.273.273,0,0,0,.193-.467L13.73,13.247A.281.281,0,0,0,13.531,13.164Z",
    transform: "translate(-1.856 -3.122)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    "data-name": "Path 3449",
    d: "M9.41.115a1.071,1.071,0,0,1,.76.315L26.615,16.875a4.567,4.567,0,0,1,1.059,4.639A3.176,3.176,0,0,0,31.661,25.5a4.871,4.871,0,0,1,1.475-.231h0A4.435,4.435,0,0,1,36.3,26.56L52.745,43.006a1.075,1.075,0,0,1,0,1.52,31.484,31.484,0,0,1-10.52,6.964,31.918,31.918,0,0,1-12.017,2.335A31.264,31.264,0,0,1,18.54,51.593,30.449,30.449,0,0,1,1.52,34.478,31.286,31.286,0,0,1-.646,22.631a31.926,31.926,0,0,1,2.4-11.839A31.491,31.491,0,0,1,8.65.43,1.071,1.071,0,0,1,9.41.115ZM30.7,27.8a5.324,5.324,0,0,1-5.073-6.937,2.426,2.426,0,0,0-.529-2.469L9.424,2.724A29.543,29.543,0,0,0,1.5,22.653a28.482,28.482,0,0,0,28.7,29.021,29.511,29.511,0,0,0,20.244-7.922L34.78,28.081a2.3,2.3,0,0,0-1.644-.659h0a2.725,2.725,0,0,0-.825.13A5.331,5.331,0,0,1,30.7,27.8Z",
    transform: "translate(0.184 -0.033)",
    fill: "#22294b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3450",
    "data-name": "Path 3450",
    d: "M53.838,41.816a1.075,1.075,0,0,1-.613-1.959,23.264,23.264,0,0,0,2.432-1.936L41.946,24.21a2.026,2.026,0,0,0-2.008-.489A4.912,4.912,0,0,1,33.9,17.683a2.026,2.026,0,0,0-.489-2.008L19.7,1.965a23.338,23.338,0,0,0-1.934,2.43A1.075,1.075,0,1,1,16,3.171a25.52,25.52,0,0,1,2.924-3.5,1.075,1.075,0,0,1,1.52,0L34.934,14.156a4.175,4.175,0,0,1,1.032,4.134,2.764,2.764,0,0,0,3.368,3.368,4.174,4.174,0,0,1,4.134,1.031L57.955,37.179a1.075,1.075,0,0,1,0,1.52,25.452,25.452,0,0,1-3.506,2.927A1.07,1.07,0,0,1,53.838,41.816Z",
    transform: "translate(-4.481 0.183)",
    fill: "#22294b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangesBl);
export default __webpack_public_path__ + "static/media/Oranges-bl.c11b20f5241c19e95a4aeff2e238862a.svg";
export { ForwardRef as ReactComponent };